(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1698],{

/***/ 326:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;

"use client";

var _interopRequireDefault = __webpack_require__(4836);
__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;
var _createSvgIcon = _interopRequireDefault(__webpack_require__(4938));
var _jsxRuntime = __webpack_require__(5893);
var _default = exports.Z = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"
}), 'Menu');

/***/ }),

/***/ 4931:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/careers",
      function () {
        return __webpack_require__(121);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AppWrapperContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6886);
/* harmony import */ var _AppNavBar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7486);



function AppWrapperContainer(param) {
    let { children , nav , navBgColor  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        sx: {
            paddingTop: {
                xs: "55px",
                md: "72px"
            }
        },
        children: [
            nav ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppNavBar__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                navBgColor: navBgColor
            }) : null,
            children
        ]
    });
}


/***/ }),

/***/ 2448:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Seo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);


function toRobotsContent(robots) {
    if (!robots) return undefined;
    var _index;
    const index = (_index = robots.index) !== null && _index !== void 0 ? _index : true;
    var _follow;
    const follow = (_follow = robots.follow) !== null && _follow !== void 0 ? _follow : true;
    return "".concat(index ? "index" : "noindex", ", ").concat(follow ? "follow" : "nofollow");
}
function Seo(props) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    const description = (ref = props.description) === null || ref === void 0 ? void 0 : ref.trim();
    const canonicalUrl = (ref1 = props.canonicalUrl) === null || ref1 === void 0 ? void 0 : ref1.trim();
    var ref13;
    const ogTitle = (ref13 = (ref2 = props.openGraph) === null || ref2 === void 0 ? void 0 : ref2.title) !== null && ref13 !== void 0 ? ref13 : props.title;
    var ref14;
    const ogDescription = (ref14 = (ref3 = props.openGraph) === null || ref3 === void 0 ? void 0 : ref3.description) !== null && ref14 !== void 0 ? ref14 : description;
    var ref15;
    const ogType = (ref15 = (ref4 = props.openGraph) === null || ref4 === void 0 ? void 0 : ref4.type) !== null && ref15 !== void 0 ? ref15 : "website";
    var ref16;
    const ogUrl = (ref16 = (ref5 = props.openGraph) === null || ref5 === void 0 ? void 0 : ref5.url) !== null && ref16 !== void 0 ? ref16 : canonicalUrl;
    var ref17;
    const twCard = (ref17 = (ref6 = props.twitter) === null || ref6 === void 0 ? void 0 : ref6.card) !== null && ref17 !== void 0 ? ref17 : "summary_large_image";
    var ref18;
    const twTitle = (ref18 = (ref7 = props.twitter) === null || ref7 === void 0 ? void 0 : ref7.title) !== null && ref18 !== void 0 ? ref18 : props.title;
    var ref19;
    const twDescription = (ref19 = (ref8 = props.twitter) === null || ref8 === void 0 ? void 0 : ref8.description) !== null && ref19 !== void 0 ? ref19 : description;
    var ref20;
    const twUrl = (ref20 = (ref9 = props.twitter) === null || ref9 === void 0 ? void 0 : ref9.url) !== null && ref20 !== void 0 ? ref20 : canonicalUrl;
    const robotsContent = toRobotsContent(props.robots);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: props.title
            }, "title"),
            description ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description
            }, "description") : null,
            props.keywords ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: props.keywords
            }, "keywords") : null,
            canonicalUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }, "canonical") : null,
            robotsContent ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: robotsContent
            }, "robots") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: ogTitle
            }, "og:title"),
            ogDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: ogDescription
            }, "og:description") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: ogType
            }, "og:type"),
            ((ref10 = props.openGraph) === null || ref10 === void 0 ? void 0 : ref10.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: props.openGraph.image
                    }, "og:image"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:secure_url",
                        content: props.openGraph.image
                    }, "og:image:secure_url")
                ]
            }) : null,
            ogUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: ogUrl
            }, "og:url") : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: twCard
            }, "twitter:card"),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: twTitle
            }, "twitter:title"),
            twDescription ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: twDescription
            }, "twitter:description") : null,
            ((ref11 = props.twitter) === null || ref11 === void 0 ? void 0 : ref11.image) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: props.twitter.image
            }, "twitter:image") : null,
            twUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:url",
                content: twUrl
            }, "twitter:url") : null,
            (ref12 = props.jsonLd) === null || ref12 === void 0 ? void 0 : ref12.map((block, idx)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(block)
                    }
                }, "jsonld-".concat(idx))),
            props.children
        ]
    });
}


/***/ }),

/***/ 121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(6886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(5861);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(9417);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./components/AppWrapperContainer.tsx
var AppWrapperContainer = __webpack_require__(4208);
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/careerBgMobile.webp
/* harmony default export */ var careerBgMobile = ({"src":"/_next/static/media/careerBgMobile.2d12e0b1.webp","height":1488,"width":720,"blurDataURL":"data:image/webp;base64,UklGRoYAAABXRUJQVlA4WAoAAAAQAAAAAwAABwAAQUxQSCEAAAAA////////////////////////////////2dzp2QAFOAAAVlA4ID4AAADwAQCdASoEAAgAAkA4JQBOiP/wPQBwYsAA/vkvSVL2KtfhAJSjPy/yCofA+scbD58G4c+jvo6TWUAO28AAAA==","blurWidth":4,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/careerBgForXtraLarge.webp
/* harmony default export */ var careerBgForXtraLarge = ({"src":"/_next/static/media/careerBgForXtraLarge.890ccfea.webp","height":912,"width":2560,"blurDataURL":"data:image/webp;base64,UklGRnQAAABXRUJQVlA4WAoAAAAQAAAABwAAAgAAQUxQSBkAAAABHyAkIP4Xb1VuRESMQSCQ5C812R4R/Q9oAFZQOCA0AAAAsAEAnQEqCAADAAJAOCUAToAilGqcxAD+9fGwlnNvIDmJ/lAjLrQQTk8R9Pbd/64ubIbwAA==","blurWidth":8,"blurHeight":3});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/careerCompleteBg.webp
/* harmony default export */ var careerCompleteBg = ({"src":"/_next/static/media/careerCompleteBg.c55362c6.webp","height":1622,"width":2238,"blurDataURL":"data:image/webp;base64,UklGRloAAABXRUJQVlA4IE4AAADQAQCdASoIAAYAAkA4JQBOgB6I4sREAAD+9MAg8iJfv9xIyaFlBt9jdD/wsfhEJVjAzTYASaE5cEFLL8kOGXD0UMqyZN8DdGyYpBRoAAA=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/ESOPS.webp
/* harmony default export */ var ESOPS = ({"src":"/_next/static/media/ESOPS.0ce1eb1e.webp","height":240,"width":240,"blurDataURL":"data:image/webp;base64,UklGRrIAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDcAAAABN6AmAAFGLREF9q0aERG4Qx2sIslqLIhkYEj/WQECkgJwcBfR/5jtNwNOhGshWUgBvgFn9mcAAFZQOCBUAAAAsAIAnQEqCAAIAAJAOCUAToDDUNQA/QA+q6ydR7oAAP73bD564x/vt3bfKsGtXWHKkBHXEL4pNaEIeyBcFDdPXFvDQLhr1Efh74NkimN90c/k+AAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/bestGadget.webp
/* harmony default export */ var bestGadget = ({"src":"/_next/static/media/bestGadget.39143400.webp","height":240,"width":240,"blurDataURL":"data:image/webp;base64,UklGRrgAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDcAAAABN6AmAAFGLREF9q0aERG4Qx2sIslqLIhkYEj/WQECkgJwcBfR/5jtNwNOhGshWUgBvgFn9mcAAFZQOCBaAAAA0AIAnQEqCAAIAAJAOCWQAnQGGAehXvgH6AGqDiIusAD+9V1utariYYie9ZXLLNOZBczEqjq+qTsNNPA81fOkynOzd71tHOLsYNg6dj3B/0K9Z2E764JMgAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/teamOutings.webp
/* harmony default export */ var teamOutings = ({"src":"/_next/static/media/teamOutings.3a3a28c7.webp","height":240,"width":240,"blurDataURL":"data:image/webp;base64,UklGRq4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSDcAAAABN6AmAAFGLREF9q0aERG4Qx2sIslqLIhkYEj/WQECkgJwcBfR/5jtNwNOhGshWUgBvgFn9mcAAFZQOCBQAAAAUAIAnQEqCAAIAAJAOCUAAZYB+gB9V1iaM94AAP7yf4OyxAKZU33q38cX9ZTuJi/L2+ck/yU77ddFjfHPYwcyswX3BgwXSiua0/uk/U/lAAA=","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg1.webp
/* harmony default export */ var officeImg1 = ({"src":"/_next/static/media/officeImg1.77efe628.webp","height":320,"width":320,"blurDataURL":"data:image/webp;base64,UklGRlwAAABXRUJQVlA4IFAAAABwAgCdASoIAAgAAkA4JaACdGuAt/8D7JHJum1AAP3hwsKhw5hN6eI/9jaOriG6z/4bdvrt1cG9Imou7qSr82R0ZGf3mz24Ke0ke/yiQWTgAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg2.webp
/* harmony default export */ var officeImg2 = ({"src":"/_next/static/media/officeImg2.8d136a4c.webp","height":712,"width":704,"blurDataURL":"data:image/webp;base64,UklGRmQAAABXRUJQVlA4IFgAAADwAQCdASoIAAgAAkA4JQBOgB6XfCHaYAAA/I+Jer/05/gkps6H+GYHD6pltUft3+YEWiZYFuztBrzsGcJcnVK7s/0kxNgZqSze3Uw9hvUbvXPYPJEL39AA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg3.webp
/* harmony default export */ var officeImg3 = ({"src":"/_next/static/media/officeImg3.369027e2.webp","height":512,"width":512,"blurDataURL":"data:image/webp;base64,UklGRpIAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSBIAAAABD/D1/4iIIBBIVs99iIj+hwZWUDggWgAAALABAJ0BKggACAACQDgliAJ0APN6yOAA/uit28aUfkgev9qJ/VWfhF+LJfb93jC9RVe9z35v+cMLWMVQ7M3IcNV1qDu9nJD/nQBl1JqvrpIrbG3eRti06LQAAA==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg4.webp
/* harmony default export */ var officeImg4 = ({"src":"/_next/static/media/officeImg4.02f378c0.webp","height":512,"width":514,"blurDataURL":"data:image/webp;base64,UklGRpAAAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSB4AAAABF0CQbePPOoXt14iIuIBA0oYt2aMt/TNE9D+MPQNWUDggTAAAANABAJ0BKggACAACQDgllAJ0APSRe9wgAM49s45jvl9xPjviW8JcBTiWYGeueqQO3p9rJ/gVEpcAWpAN8SnefmcnRsJS4y8QBA3AAAA=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg5.webp
/* harmony default export */ var officeImg5 = ({"src":"/_next/static/media/officeImg5.b69034aa.webp","height":720,"width":512,"blurDataURL":"data:image/webp;base64,UklGRoYAAABXRUJQVlA4WAoAAAAQAAAABQAABwAAQUxQSBMAAAABD/D6/4iIIBBIVslfc4iI/ocGAFZQOCBMAAAA8AEAnQEqBgAIAAJAOCWMAnQBDukvWwuwAPzs//RrK0nWmM2z1B5h34nktQFtZE20FuNHTTi+8KkGYEhADCTmE5Nhnqh/6yFHO36gAA==","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/officeImg6.webp
/* harmony default export */ var officeImg6 = ({"src":"/_next/static/media/officeImg6.2fa2925a.webp","height":712,"width":704,"blurDataURL":"data:image/webp;base64,UklGRo4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSBIAAAABD/D6/4iIIBBIVs99iIj+hwZWUDggVgAAABACAJ0BKggACAACQDglsAJ0ugACuq1gNtgA/q3jwfrxY/yrxCw8XRbU4QDt9F6l9MnYgZZhW7xoZp95pwGv8MrP+pvvD/GYeTf8Ww1j6zN5oe/sAAAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/floatingIcon1.webp
/* harmony default export */ var floatingIcon1 = ({"src":"/_next/static/media/floatingIcon1.af5371ba.webp","height":144,"width":114,"blurDataURL":"data:image/webp;base64,UklGRqYAAABXRUJQVlA4WAoAAAAQAAAABQAABwAAQUxQSDEAAAAAhfDuggEAZf7//2kAAIf//74AAFKv/7gAHCkGt1cAEzMACVUAAFIAAA1UAA1RSEo/AFZQOCBOAAAAEAIAnQEqBgAIAAJAOCUAToj/8D8EHPjIgAD+4oXPslmNcv9e12Mlxx+wR3MihwwCkRXvraeCxdBxZXuJLxBsnS/fct4ib4vyUy2KHwAA","blurWidth":6,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/floatingIcon2.webp
/* harmony default export */ var floatingIcon2 = ({"src":"/_next/static/media/floatingIcon2.c29ba3ee.webp","height":182,"width":188,"blurDataURL":"data:image/webp;base64,UklGRr4AAABXRUJQVlA4WAoAAAAQAAAABwAABwAAQUxQSD0AAAABYFLbtpTDpJBIEswEAItHEwRJFEIQgwZEmf/8M0TEBOA9pEa1iw7y7RVihuwUQkyQrJcQI0BziN4gXgoAAFZQOCBaAAAAsAEAnQEqCAAIAAJAOCWYAnQAzLTowAD5Xd17uDCQvM1/Kf7cP30dD4BuCWZbfSbsN8o9569yfWrPPqPyEwMjFwJYef5QJ/6gPj/bbFJERpu4j4PmrQIijoAA","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/floatingIcon3.webp
/* harmony default export */ var floatingIcon3 = ({"src":"/_next/static/media/floatingIcon3.1951b999.webp","height":216,"width":304,"blurDataURL":"data:image/webp;base64,UklGRpoAAABXRUJQVlA4WAoAAAAQAAAABwAABQAAQUxQSDEAAAAAAAAAAAE7hmcAAAAAG8GCZgAAE0BW1AAAAABk1bFEAAAdHqdIAAAAAGzkugkAAAAAAFZQOCBCAAAA0AEAnQEqCAAGAAJAOCWUAnQA3ZCDE5AA/rxQa6cPgVTvz/CQ5LzF1MUW7ZsMy0hR/dIrdon5RHGM2u0S6XZD+AAA","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/career/GromoGallery.tsx












const GromoGallery_images = [
    {
        src: officeImg5,
        alt: "officeImg5"
    },
    {
        src: officeImg6,
        alt: "officeImg6"
    },
    {
        src: officeImg3,
        alt: "officeImg3"
    },
    {
        src: officeImg4,
        alt: "officeImg4"
    },
    {
        src: officeImg2,
        alt: "officeImg2"
    },
    {
        src: officeImg1,
        alt: "officeImg1"
    }
];
const floatingIcons = [
    {
        src: floatingIcon1,
        alt: "floatingIcon1",
        style: {
            top: "18%",
            right: "15%"
        }
    },
    {
        src: floatingIcon2,
        alt: "floatingIcon2",
        style: {
            left: "10%",
            right: "20%",
            bottom: "10%"
        }
    },
    {
        src: floatingIcon3,
        alt: "floatingIcon3",
        style: {
            top: "4%",
            right: "11%"
        }
    }
];
function GromoGallery() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
            padding: "4%",
            display: "grid",
            margin: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    color: "#0A0C0F",
                    fontSize: {
                        xs: "20px",
                        md: "32px"
                    },
                    lineHeight: {
                        md: "40px"
                    },
                    fontWeight: 500,
                    textAlign: "center",
                    margin: {
                        md: "12px 0 48px 0"
                    }
                },
                children: [
                    "Collaborate with the best of",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: "40px"
                        },
                        children: "brains"
                    }),
                    " and",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: "40px"
                        },
                        children: "hearts."
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                sx: {
                    display: "grid",
                    gridTemplateColumns: "3fr 6fr 3fr",
                    width: "80%",
                    margin: "30px auto",
                    position: "relative"
                },
                children: [
                    GromoGallery_images.map((img, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                            sx: {
                                padding: "2%",
                                display: "grid",
                                placeContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: img.src,
                                alt: img.alt,
                                style: {
                                    objectFit: "contain",
                                    borderRadius: "12px"
                                },
                                loading: "lazy"
                            })
                        }, idx)),
                    floatingIcons.map((icon, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: icon.src,
                            alt: icon.alt,
                            style: {
                                position: "absolute",
                                height: "70px",
                                objectFit: "contain",
                                ...icon.style
                            },
                            loading: "lazy"
                        }, idx))
                ]
            })
        ]
    });
}
/* harmony default export */ var career_GromoGallery = (GromoGallery);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(6066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(1548);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(3873);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(4253);
;// CONCATENATED MODULE: ./components/career/GromoGalleryMobile.tsx













const GromoGalleryMobile_images = [
    {
        src: officeImg5,
        alt: "officeImg5"
    },
    {
        src: officeImg6,
        alt: "officeImg6"
    },
    {
        src: officeImg4,
        alt: "officeImg4"
    },
    {
        src: officeImg3,
        alt: "officeImg3"
    },
    {
        src: officeImg2,
        alt: "officeImg2"
    },
    {
        src: officeImg1,
        alt: "officeImg1"
    }
];
const settings = {
    infinite: false,
    speed: 1500,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    easing: "linear",
    slidesToShow: 1,
    ariaHidden: true,
    slidesToScroll: 1
};
function GromoGalleryMobile() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
            margin: "24px 0 0 0"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    color: "#0A0C0F",
                    fontSize: {
                        xs: "18px",
                        md: "32px"
                    },
                    lineHeight: {
                        xs: "32px",
                        md: "40px"
                    },
                    wordSpacing: {
                        xs: "2px"
                    },
                    fontWeight: 500,
                    textAlign: "center",
                    margin: {
                        xs: "50px auto 20px auto",
                        md: "0 0 15px 0"
                    },
                    width: "80%"
                },
                children: [
                    "Collaborate with the best of",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "br",
                        sx: {
                            display: {
                                xs: "block",
                                sm: "none"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: "28px",
                            margin: "0 4px"
                        },
                        children: "brains"
                    }),
                    "and",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: "28px",
                            margin: "0 4px"
                        },
                        children: "hearts"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                ...settings,
                children: GromoGalleryMobile_images.map((img, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            padding: {
                                xs: "16%",
                                md: "2%"
                            },
                            display: "grid !important",
                            placeContent: "center",
                            margin: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            src: img.src,
                            alt: img.alt,
                            style: {
                                objectFit: "contain",
                                borderRadius: "12px",
                                height: "350px"
                            },
                            loading: "lazy"
                        })
                    }, idx))
            })
        ]
    });
}
/* harmony default export */ var career_GromoGalleryMobile = (GromoGalleryMobile);

// EXTERNAL MODULE: ./components/AppFooter.tsx + 6 modules
var AppFooter = __webpack_require__(9705);
// EXTERNAL MODULE: ./node_modules/@mui/material/Modal/Modal.js + 5 modules
var Modal = __webpack_require__(8586);
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/greenWave.webp
/* harmony default export */ var greenWave = ({"src":"/_next/static/media/greenWave.78b0cecd.webp","height":765,"width":2880,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAAJyAaFBAOEBkXHCIpLzMxJgBWUDggMAAAAJABAJ0BKggAAgACQDglnAAC50/g4AD+m9h/jic9PhsHbuJ3kYgIpxemLYXOEgAAAA==","blurWidth":8,"blurHeight":2});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/blueWave.webp
/* harmony default export */ var blueWave = ({"src":"/_next/static/media/blueWave.0d4b48cd.webp","height":594,"width":2880,"blurDataURL":"data:image/webp;base64,UklGRmgAAABXRUJQVlA4WAoAAAAQAAAABwAAAQAAQUxQSBEAAAAACAQEBwwTGyIYIiYoJyYlJABWUDggMAAAALABAJ0BKggAAgACQDglnAAC94Np6gAA+Xct/+L2V92ONQUkctsZyGEUxesNDgAAAA==","blurWidth":8,"blurHeight":2});
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(594);
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/AnuprekshaThumb.webp
/* harmony default export */ var AnuprekshaThumb = ({"src":"/_next/static/media/AnuprekshaThumb.44c9d792.webp","height":720,"width":1280,"blurDataURL":"data:image/webp;base64,UklGRkwAAABXRUJQVlA4IEAAAACwAQCdASoIAAUAAkA4JZACdADyfvaAAP75Adpn2zgj3+qbj//LeuhfhdMTuOHBQ9Jj+yYNiMkIh3bu8i0n8AAA","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/AnkitSirThumb.webp
/* harmony default export */ var AnkitSirThumb = ({"src":"/_next/static/media/AnkitSirThumb.b30d8bec.webp","height":720,"width":1280,"blurDataURL":"data:image/webp;base64,UklGRk4AAABXRUJQVlA4IEIAAADQAQCdASoIAAUAAkA4JYwCdAD0mLRwkAD+wr3bPj69q8Y7x+r9UPx9W8B2LY2p56u9692/62Ulsu6tKqP1oNAIAAA=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./public/assets/images/home/more/career/RajatThumb.webp
/* harmony default export */ var RajatThumb = ({"src":"/_next/static/media/RajatThumb.fe3f66e3.webp","height":720,"width":1280,"blurDataURL":"data:image/webp;base64,UklGRkQAAABXRUJQVlA4IDgAAACwAQCdASoIAAUAAkA4JZACdADx+XPAAP7woFs4vbT/VTW1bjwd4pgOb/HwQweanJmwUKvEA6qEAA==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./components/career/Stories.tsx













const videoTestimonial = [
    {
        src: "https://www.youtube.com/embed/T0mXtyuS8X0?autoplay=1"
    },
    {
        src: "https://www.youtube.com/embed/0F548gc1Xq4?autoplay=1"
    },
    {
        src: "https://www.youtube.com/embed/iqQJnQBN9hs?autoplay=1"
    }
];
const thumbnails = [
    {
        src: AnkitSirThumb,
        alt: "Ankit"
    },
    {
        src: AnuprekshaThumb,
        alt: "Anupreksha"
    },
    {
        src: RajatThumb,
        alt: "Rajat"
    }
];
const sliderSettings = {
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 4000,
    pauseOnHover: false,
    arrows: true,
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1
};
function Stories() {
    const [showVideo, setShowVideo] = (0,react.useState)(false);
    const [videoId, setVideoId] = (0,react.useState)(0);
    const playFunction = (id)=>{
        setShowVideo(true);
        setVideoId(id);
    };
    const pauseFunction = ()=>{
        setShowVideo(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
        sx: {
            padding: "4%",
            position: "relative",
            display: "grid",
            margin: "auto"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                sx: {
                    fontWeight: 500,
                    fontSize: {
                        xs: "18px",
                        md: "32px"
                    },
                    lineHeight: {
                        xs: "24px",
                        md: "40px"
                    },
                    textAlign: "center",
                    margin: {
                        xs: "20px 0",
                        md: "20px 0 48px 0"
                    }
                },
                children: [
                    "Hear it from the",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        component: "br",
                        sx: {
                            display: {
                                xs: "block",
                                sm: "none"
                            }
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        style: {
                            fontWeight: 700,
                            fontSize: "40px"
                        },
                        children: " team"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                sx: {
                    overflow: "hidden",
                    width: {
                        xs: "100%",
                        md: "966px"
                    },
                    height: {
                        xs: "280px",
                        md: "543px"
                    },
                    margin: "auto"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                    ...sliderSettings,
                    children: thumbnails.map((thumbnail, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    md: "966px"
                                },
                                height: {
                                    xs: "280px",
                                    md: "543px"
                                },
                                display: "flex !important",
                                justifyContent: "center",
                                alignItems: "center",
                                margin: "0px 10px",
                                cursor: "pointer"
                            },
                            onClick: ()=>playFunction(index),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: thumbnail.src,
                                alt: thumbnail.alt,
                                style: {
                                    objectFit: "contain"
                                },
                                loading: "lazy"
                            })
                        }, thumbnail.alt))
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                open: showVideo,
                onClose: pauseFunction,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        height: "100%",
                        width: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        background: "#0A0C0F50"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: "iframe",
                            src: videoTestimonial[videoId].src,
                            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                            allowFullScreen: true,
                            sx: {
                                width: "80%",
                                height: {
                                    xs: "50%",
                                    md: "80%"
                                },
                                objectFit: "contain",
                                border: 0
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {
                            sx: {
                                position: "absolute",
                                top: "2%",
                                right: "2%",
                                color: "#bfbfbf",
                                fontSize: "38px",
                                zIndex: 100
                            },
                            onClick: pauseFunction
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: greenWave,
                alt: "",
                style: {
                    position: "absolute",
                    width: "100%",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    margin: "auto 0",
                    zIndex: -1
                },
                loading: "lazy"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                src: blueWave,
                alt: "",
                style: {
                    position: "absolute",
                    width: "100%",
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    margin: "auto 0",
                    zIndex: -1
                },
                loading: "lazy"
            })
        ]
    });
}
/* harmony default export */ var career_Stories = (Stories);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/career/CurrentOpening.tsx



function CurrentOpening(param) {
    let { jobs  } = param;
    const openings = [
        {
            role: "Graphic designer-Video Editor",
            link: "https://gromo-graphicdesigner.lovable.app"
        },
        {
            role: "Sr UI/UX Designer",
            link: "https://zyra-senioruiuxdesigner.lovable.app"
        },
        {
            role: "Sr Product Manager"
        },
        {
            role: "Marketing Intern",
            link: "https://gromo-marketingintern.lovable.app"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
            sx: {
                padding: {
                    xs: "6% 4%",
                    md: "4%"
                },
                backgroundColor: "#F4F7FF",
                margin: "50px auto 20px auto",
                display: {
                    xs: "flex",
                    md: ""
                },
                justifyContent: {
                    xs: "center",
                    md: ""
                },
                alignItems: {
                    xs: "center",
                    md: ""
                },
                flexDirection: {
                    xs: "column",
                    md: ""
                },
                maxWidth: "1440px"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                    sx: {
                        width: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            component: "h2",
                            sx: {
                                fontWeight: 700,
                                fontSize: "36px",
                                lineHeight: {
                                    xs: "",
                                    md: "44px"
                                },
                                textAlign: "center",
                                margin: "10px 0"
                            },
                            children: "We’re hiring"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            sx: {
                                fontWeight: 500,
                                fontSize: "14px",
                                lineHeight: {
                                    xs: "",
                                    md: "24px"
                                },
                                textAlign: "center",
                                margin: {
                                    xs: "auto",
                                    md: "10px 0"
                                },
                                color: "#393F50",
                                width: {
                                    xs: "100%",
                                    md: "100%"
                                }
                            },
                            children: "People are our greatest strength. Want to do the best work of your life ? Join our rocket ship"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                    sx: {
                        display: "grid",
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr"
                        },
                        margin: {
                            xs: "16px 24px",
                            md: "20px auto"
                        },
                        width: "100%",
                        padding: "1%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        children: openings.map((item, i)=>{
                            const button = /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                variant: "contained",
                                disabled: !item.link,
                                sx: {
                                    "&:hover": {
                                        backgroundColor: "#08AC17"
                                    },
                                    backgroundColor: "#08AC17",
                                    color: "white",
                                    padding: "8px 24px",
                                    width: {
                                        xs: "80%",
                                        md: "fit-content"
                                    },
                                    margin: {
                                        xs: "8px auto",
                                        md: "auto"
                                    },
                                    display: {
                                        xs: "block"
                                    },
                                    fontSize: {
                                        xs: "16px",
                                        md: "14px"
                                    }
                                },
                                children: "View Opening"
                            });
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                sx: {
                                    padding: "2%",
                                    width: {
                                        xs: "100%",
                                        md: "90%"
                                    },
                                    margin: "16px auto",
                                    display: {
                                        xs: "block",
                                        md: "grid"
                                    },
                                    gridTemplateColumns: "8fr 4fr",
                                    placeContent: "center",
                                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.05)",
                                    backgroundColor: "white",
                                    borderRadius: "4px"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                sx: {
                                                    display: "flex",
                                                    alignItems: "center",
                                                    fontWeight: 600,
                                                    fontSize: "20px",
                                                    lineHeight: "32px",
                                                    color: "#001833",
                                                    padding: " 0 10px 0 20px",
                                                    margin: {
                                                        xs: "8px 0"
                                                    }
                                                },
                                                children: item.role
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                sx: {
                                                    fontWeight: 600,
                                                    fontSize: {
                                                        xs: "14px",
                                                        md: "16px"
                                                    },
                                                    lineHeight: {
                                                        xs: "20px"
                                                    },
                                                    color: "#001833",
                                                    padding: " 0 10px 0 20px",
                                                    margin: {
                                                        xs: "8px 0"
                                                    }
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        style: {
                                                            fontSize: "14px",
                                                            color: "#9EA2AE",
                                                            fontWeight: 500,
                                                            margin: "12px 0"
                                                        },
                                                        children: "Location"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                    " Gurgaon"
                                                ]
                                            })
                                        ]
                                    }),
                                    item.link ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: item.link,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: button
                                    }) : button
                                ]
                            }, i);
                        })
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var career_CurrentOpening = (CurrentOpening);

// EXTERNAL MODULE: ./components/Seo.tsx
var Seo = __webpack_require__(2448);
;// CONCATENATED MODULE: ./pages/careers/index.tsx
/* provided dependency */ var process = __webpack_require__(3454);


















function Careers(props) {
    var ref;
    const [floatingBtn, setFloatingBtn] = (0,react.useState)(true);
    const siteUrl = ((ref = process.env.NEXT_PUBLIC_SITE_URL) === null || ref === void 0 ? void 0 : ref.replace(/\/+$/, "")) || "https://gromo.in";
    const jobPostingsJsonLd = Array.isArray(props === null || props === void 0 ? void 0 : props.jobs) && props.jobs.length ? {
        "@context": "https://schema.org",
        "@graph": props.jobs.filter((job)=>{
            return Boolean(job === null || job === void 0 ? void 0 : job.position);
        }).map((job)=>({
                "@type": "JobPosting",
                title: String(job.position),
                description: [
                    job.department,
                    job.experience
                ].filter(Boolean).map(String).join(" • "),
                hiringOrganization: {
                    "@id": "".concat(siteUrl, "/#organization")
                },
                jobLocation: {
                    "@type": "Place",
                    address: {
                        "@type": "PostalAddress",
                        addressLocality: "Gurugram",
                        addressRegion: "Haryana",
                        addressCountry: "IN"
                    }
                },
                applicantLocationRequirements: {
                    "@type": "Country",
                    name: "IN"
                },
                url: job.link ? String(job.link) : "".concat(siteUrl, "/careers")
            }))
    } : null;
    (0,react.useEffect)(()=>{
        var ref;
        (ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.addEventListener("scroll", handleScroll, {
            passive: true
        });
    }, []);
    const handleScroll = (event)=>{
        var ref;
        if (((ref = globalThis.window) === null || ref === void 0 ? void 0 : ref.pageYOffset) > 2500) {
            setFloatingBtn(false);
        } else {
            setFloatingBtn(true);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Seo/* default */.Z, {
                title: "Careers at GroMo | Join India’s Fastest Growing Fintech",
                description: "We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best.",
                keywords: "Join GroMo today",
                openGraph: {
                    title: "Careers at GroMo | Join India’s Fastest Growing Fintech",
                    description: "We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best.",
                    type: "website",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                twitter: {
                    title: "Careers at GroMo | Join India's Fastest Growing Fintech Platform",
                    description: "We're Hiring! Check the career page and Join GroMo today. Discover the latest job openings and apply for the profile that suits you best.",
                    url: "https://gromo.in/careers",
                    image: "https://elasticbeanstalk-ap-south-1-812175807951.s3.ap-south-1.amazonaws.com/static-resources/notification-resources/notification_images/1668084562_Meta+Image-low+size.webp"
                },
                jsonLd: jobPostingsJsonLd ? [
                    jobPostingsJsonLd
                ] : undefined
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppWrapperContainer/* default */.Z, {
                nav: true,
                navBgColor: "#002561",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        sx: {
                            minHeight: {
                                xs: "95vh",
                                md: "1000px",
                                lg: "551px"
                            },
                            justifyContent: "space-evenly",
                            color: "black",
                            padding: {
                                xs: "4%",
                                md: "4%",
                                lg: "3% 11%"
                            },
                            background: {
                                xs: 'url("'.concat(careerBgMobile.src, '")'),
                                md: 'url("'.concat(careerCompleteBg.src, '")'),
                                xl: 'url("'.concat(careerBgForXtraLarge.src, '")')
                            },
                            backgroundSize: {
                                xs: "cover",
                                md: "cover",
                                xl: "contain"
                            },
                            backgroundRepeat: {
                                xs: "no-repeat",
                                md: "no-repeat",
                                xl: "no-repeat"
                            },
                            backgroundPosition: {
                                xs: "bottom",
                                md: "bottom",
                                xl: ""
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            sx: {
                                minHeight: "200px",
                                color: "white",
                                zIndex: "1"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "h1",
                                    textAlign: "center",
                                    fontWeight: "600",
                                    margin: "15px 0",
                                    sx: {
                                        fontSize: {
                                            xs: "28px",
                                            md: "40px"
                                        },
                                        lineHeight: {
                                            xs: "36px",
                                            md: "56px"
                                        }
                                    },
                                    children: "Build Fast. All day. Every Day."
                                }),
                                [
                                    "We build innovative products & solutions that help elevate",
                                    "the lives of millions of users across India"
                                ].map((item, i)=>{
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        textAlign: "center",
                                        margin: "5px 0",
                                        fontWeight: "400",
                                        sx: {
                                            fontSize: {
                                                xs: "16px",
                                                md: "20px"
                                            },
                                            lineHeight: {
                                                xs: "24px",
                                                md: "32px"
                                            }
                                        },
                                        children: item
                                    }, i);
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    sx: {
                                        position: {
                                            xs: "absolute",
                                            lg: "static"
                                        },
                                        bottom: 0,
                                        left: 0,
                                        right: 0,
                                        top: "272px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "#currentOpening",
                                        style: {
                                            textDecoration: "none",
                                            color: "white"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            variant: "contained",
                                            sx: {
                                                backgroundColor: "#08AC17",
                                                padding: "12px 24px",
                                                display: {
                                                    xs: floatingBtn ? "block" : "none",
                                                    md: "block"
                                                },
                                                margin: "15px auto",
                                                color: "white",
                                                zIndex: 6,
                                                "&:hover": {
                                                    backgroundColor: "#08AC17"
                                                },
                                                width: {
                                                    xs: "320px",
                                                    md: "fit-content"
                                                }
                                            },
                                            children: "Come, join us!"
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "block",
                                md: "none"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(career_GromoGalleryMobile, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            display: {
                                xs: "none",
                                md: "block"
                            },
                            maxWidth: "1440px",
                            margin: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(career_GromoGallery, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(career_Stories, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                        sx: {
                            width: "100%",
                            display: "grid",
                            gridTemplateColumns: {
                                xs: "1fr",
                                md: "1fr 1fr"
                            },
                            padding: "4%",
                            margin: "auto",
                            maxWidth: "1440px"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "h2",
                                sx: {
                                    fontWeight: "700",
                                    fontSize: {
                                        xs: "28px",
                                        md: "32px"
                                    },
                                    lineHeight: {
                                        xs: "36px",
                                        md: "40px"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "75%"
                                    },
                                    margin: {
                                        xs: "8px auto",
                                        md: "auto"
                                    }
                                },
                                children: "Get ready for a 100% awesome GroMo experience"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                sx: {
                                    fontWeight: {
                                        xs: "400",
                                        md: "500"
                                    },
                                    fontSize: {
                                        xs: "16px",
                                        md: "18px"
                                    },
                                    lineHeight: {
                                        xs: "24px",
                                        md: "24px"
                                    },
                                    width: {
                                        xs: "100%",
                                        md: "75%"
                                    },
                                    margin: {
                                        xs: "8px auto",
                                        md: "auto"
                                    },
                                    color: "#393F50"
                                },
                                children: "We will take care that you get the best gadgets, best incentives, best work settings, best breaks and everything in between - promise!"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        sx: {
                            display: "grid",
                            // placeContent: "left",
                            gridTemplateColumns: {
                                xs: "1fr",
                                md: "1fr 1fr"
                            },
                            width: {
                                xs: "100%",
                                md: "60%"
                            },
                            margin: "auto",
                            padding: "2% 4%",
                            justifyItems: "center"
                        },
                        children: [
                            {
                                CardTitle: "ESOPS",
                                Image: ESOPS,
                                content: "Our wins are your wins. Get ESOP and performance based incentives."
                            },
                            {
                                CardTitle: "Best Gadgets",
                                Image: bestGadget,
                                content: "To win a war, a soldier needs to have arms and ammunition. Get top-notch hardware to fuel your dreams."
                            },
                            {
                                CardTitle: "Team Outings",
                                Image: teamOutings,
                                content: "It’s always a good idea to party. Join us for regular team parties and outings."
                            }
                        ].map((item, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                sx: {
                                    width: {
                                        xs: "100%",
                                        md: "70%"
                                    },
                                    margin: {
                                        xs: "20px auto",
                                        md: "10px auto"
                                    },
                                    minHeight: {
                                        xs: "fit-content",
                                        md: "300px"
                                    },
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start",
                                    alignItems: "center",
                                    textAlign: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                        sx: {
                                            margin: "8px 0"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: item.Image,
                                            alt: item.CardTitle,
                                            style: {
                                                height: "120px",
                                                objectFit: "contain",
                                                width: "fit-content"
                                            },
                                            width: 100,
                                            height: 100,
                                            loading: "lazy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: "700",
                                            fontSize: "24px",
                                            lineHeight: "36px",
                                            margin: {
                                                xs: "8px 0"
                                            }
                                        },
                                        children: item.CardTitle
                                    }, i),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        sx: {
                                            fontWeight: "500",
                                            fontSize: {
                                                xs: "16px",
                                                md: "16px"
                                            },
                                            lineHeight: {
                                                xs: "24px",
                                                md: "24px"
                                            },
                                            color: "#6C717F"
                                        },
                                        children: item.content
                                    })
                                ]
                            }, item.CardTitle);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        id: "currentOpening",
                        sx: {
                            backgroundColor: "#F4F7FF"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(career_CurrentOpening, {
                            jobs: props.jobs
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppFooter["default"], {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var careers = (Careers);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3581,6886,6499,5675,7538,5045,1033,4938,9705,7486,9774,2888,179], function() { return __webpack_exec__(4931); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);